module.exports = __webpack_public_path__ + "tab_chanpin_default.png?9fb415237bc47b06492a0904353c62d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_chanpin_default.png
// module id = 132
// module chunks = 0